exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-editable-input{position:relative}.vc-input__input{padding:0;border:0;outline:none;width:100%}.vc-input__label{text-transform:capitalize}", ""]);

// exports
